<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">“IN MEMORY”</p>
<div class="image-break">
<p class="image"><img alt="Images" src="images/11-1.jpg"/></p>
<p class="caption">Jeffrey Heagerty circa 1983. <i>Courtesy Robert Smallwood.</i></p>
</div>
<p class="noindent"><i>By Lisa-Ann McGahee, July 1984</i></p>
<p class="noindent1">For Jeff</p>
<p class="noindent1">It broke our hearts to lose you, but you did not go alone.</p>
<p class="noindent">A part of us went with you the day God took you home.</p>
<p class="noindent">A million times we need you, a million times we cried.</p>
<p class="noindent">If love could have saved you, you never would have died.</p>
<p class="noindent">To the grave we traveled, the flowers placed with care.</p>
<p class="noindent">But no one knows the heartaches as we turn and leave you there.</p>
<p class="noindent">No farewells were spoke, no time to say goodbye.</p>
<p class="noindent">You were gone before we knew, and only God knows why.</p>
<p class="noindent">If tears could build a stairway, and heartaches make a lane,</p>
<p class="noindent">we would walk our way to heaven and bring you back again.</p>
<p class="noindent">We smiled because we loved him. We cry because we lost him.</p>
<p class="noindent1"><i>Missed by Mom and Dad and Brothers and Lisa and Friends.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Inmemory.vue?05777225